module.exports = __webpack_public_path__ + "img/flag-en.1b105269.svg";